import { faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardHeader, Typography, useTheme } from "@material-ui/core";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import IsMountedRef from "src/utils/IsMountedRef";

const GrandCardBank = () => {
  const { users } = useContext(UsersData);
  const mounted = IsMountedRef();
  const [grandReceivable, setGrandExpense] = useState(0);
  const theme = useTheme();

  const getAllBank = React.useCallback(async () => {
    let response = await axios.get("accounting/grand/bank-totalamount", {
      params: {
        main_mgmt_id: users.main_mgmt_id,
      },
    });

    if (mounted.current) {
      if (response.data.length > 0) {
        calculateTotal(response.data);
      }
    }
  }, [mounted, users]);

  const calculateTotal = (data) => {
    let x = 0;

    data.forEach((element) => {
      x += parseFloat(element._total_bank_balance);
    });

    setGrandExpense(x);
  };

  useEffect(() => {
    getAllBank();
  }, [getAllBank]);

  return (
    <Card elevation={5}>
      <CardHeader
        avatar={
          <FontAwesomeIcon
            icon={faPiggyBank}
            size={"5x"}
            style={{ color: `${theme.palette.primary.main}` }}
          />
        }
        title={
          <Typography variant="h4" color="textSecondary" noWrap>
            Banks
          </Typography>
        }
        // subheader={
        //   <Typography variant="h5">
        //     <strong> &#8369; {Notify.convertToNumber(grandReceivable)} </strong>
        //   </Typography>
        // }
      />
      <Box mb={2}>
        <Typography variant="h4" align="center">
          <strong> &#8369; {Notify.convertToNumber(grandReceivable)} </strong>
        </Typography>
      </Box>
    </Card>
  );
};

export default GrandCardBank;
